import {
  SINGLE_TRANSACTION_TYPE_TRIGGER_ORDER,
  transactionStatusTypes,
  transactionStatusTypesArray,
  transactionTypeByKey,
  transactionTypes,
  transactionTypesArray,
} from '../../enum/api/transactionTypes';
import { parseEnumType } from '../enumMappers';

const normalizeField = (field) =>
  Object.keys(field).reduce((normalized, key) => {
    const transactionTypes = transactionTypeByKey[key];

    return {
      ...normalized,
      [key]: transactionTypes
        ? parseEnumType(transactionTypes, field[key])
        : field[key],
    };
  }, {});

// The single transaction API answers in the BE's codes: each field's
// CaptionType, FormatType and so on, and the transaction's StatusType and Type.
// Returns the transaction with them swapped for their names, as the
// transaction details read them.
export const normalizeSingleTransaction = (data) => ({
  ...data,
  ...(data.Fields && { Fields: data.Fields.map(normalizeField) }),
  StatusType: parseEnumType(
    Object.keys(transactionStatusTypes),
    data.StatusType,
  ),
  Type: transactionTypesArray[data.Type],
});

// The `type` to load a transaction list row's details with. A canceled or
// expired Buy at Target Price transaction loads its details as a trigger order
// (?type=TriggerOrder); any other row loads as a regular transaction, with no
// type.
export const getSingleTransactionType = ({ Type, StatusType }) => {
  const type = parseEnumType(transactionTypesArray, Type);
  const status = parseEnumType(transactionStatusTypesArray, StatusType);
  const isCancelledOrExpired =
    status === transactionStatusTypes.Canceled ||
    status === transactionStatusTypes.Expired;

  return type === transactionTypes.TriggerOrderBuy && isCancelledOrExpired
    ? SINGLE_TRANSACTION_TYPE_TRIGGER_ORDER
    : undefined;
};

// The transaction types of a Buy at Target Price order's own rows: the order,
// the reservation of its funds and the release of that reservation.
const TARGET_PRICE_ORDER_TRANSACTION_TYPES = [
  transactionTypes.TriggerOrderBuy,
  transactionTypes.TriggerOrderReserved,
  transactionTypes.TriggerOrderReservationReleased,
];

// Whether a transaction list row belongs to a Buy at Target Price order.
export const isTargetPriceOrderTransaction = ({ Type }) =>
  TARGET_PRICE_ORDER_TRANSACTION_TYPES.includes(
    parseEnumType(transactionTypesArray, Type),
  );

// What the Target Price Order details modal reads for an order: its row from
// the transaction-requests list, plus its details from the single transaction
// API. The row's own fields win: the details carry the Fields (prices,
// reference number, submitter, ...) the row doesn't, but also placeholders
// (Quantity: null, ...) that must not hide the row's values.
export const mergeTriggerOrderDetails = (details, row) => ({
  ...details,
  ...row,
});
